var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFunction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 18,
    viewBox: "0 0 12 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.81191 1.77788C10.226 1.78875 10.5705 1.46189 10.5813 1.04782C10.5922 0.633752 10.2654 0.289269 9.85128 0.278398L9.81191 1.77788ZM1.19324 15.9673C0.780495 16.0021 0.474139 16.3649 0.508974 16.7777C0.54381 17.1904 0.906647 17.4968 1.31939 17.4619L1.19324 15.9673ZM9.85128 0.278398C8.63606 0.246495 7.12425 0.640369 5.87205 1.56981C4.59682 2.51634 3.59904 4.01505 3.46812 6.13134L4.96526 6.22395C5.06695 4.58012 5.82019 3.47634 6.76606 2.77428C7.73494 2.05513 8.91428 1.75432 9.81191 1.77788L9.85128 0.278398ZM3.46812 6.13134C3.40457 7.15876 3.55767 8.33274 3.7101 9.44491C3.86717 10.5909 4.02616 11.687 4.02502 12.6759C4.02386 13.669 3.85809 14.4259 3.47267 14.9518C3.11098 15.4454 2.46174 15.8602 1.19324 15.9673L1.31939 17.4619C2.88521 17.3298 3.9941 16.7779 4.68257 15.8385C5.34731 14.9314 5.52373 13.789 5.52501 12.6776C5.52631 11.5621 5.34799 10.3486 5.19621 9.24123C5.03979 8.09997 4.91252 7.0766 4.96526 6.22395L3.46812 6.13134Z",
    fill: "#7B7986"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.15845 9.40576H8.28255",
    stroke: "#7B7986",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFunction);
export default __webpack_public_path__ + "static/media/function.cade1b94997f6bfb5d1fd4093e3776f3.svg";
export { ForwardRef as ReactComponent };